import Divider from '@mui/material/Divider';
import List from '@mui/material/List';

import { NavigationItem } from './NavigationItem';

import type { FunctionComponent } from 'react';

export const Navigation: FunctionComponent = () => {
    return (
        <List sx={{ position: 'fixed', top: '50%', transform: 'translateY(-50%)' }}>
            <NavigationItem text="pages.recruiter-profile.general-information.title" urlHash="general-information" />
            <NavigationItem text="pages.recruiter-profile.about-me.title" urlHash="about-me" />
            <NavigationItem text="pages.recruiter-profile.skills.title" urlHash="skills" />
            <NavigationItem text="pages.recruiter-profile.languages.title" urlHash="languages" />
            <NavigationItem text="pages.recruiter-profile.ambitions.title" urlHash="ambitions" />
            <Divider />
            <NavigationItem text="pages.recruiter-profile.background.work-history.title" urlHash="work-history" />
            <NavigationItem
                text="pages.recruiter-profile.background.education-history.title"
                urlHash="education-history"
            />
            <NavigationItem text="pages.recruiter-profile.background.project-history.title" urlHash="project-history" />
            <NavigationItem text="pages.recruiter-profile.background.course-history.title" urlHash="course-history" />
            <NavigationItem text="pages.recruiter-profile.background.certificates.title" urlHash="certificates" />
            <NavigationItem
                text="pages.recruiter-profile.background.publication-history.title"
                urlHash="publication-history"
            />
        </List>
    );
};
